export const BASE_INVENTORY_MOVEMENTS_PRODUCTS = {
  MOVEMENT_REASON: 'Compra',
  MOVEMENT_TYPE: 'Entrada'
}